const initialState = {
    AllEmailTemplates: [],
    AllTemplateActions:[],
    emailTemplatesObj:{}
  }
  const EmailTemplatesReducer = (state = initialState, action: { type: any; payload: any; }) => {
    switch (action.type) {
      case 'GET_TEMPLATES':
            return {
                ...state,
                AllEmailTemplates: action.payload?.val,
                emailTemplatesObj: action.payload?.objVal,
            };
      case 'GET_ACTIONS':
            return {
                ...state,
                AllTemplateActions: action.payload,
            };
        default:
            return state;
    }
  }
  
  export default EmailTemplatesReducer;
  